import * as signalR from '@microsoft/signalr';
import { API_BASE_URL } from '../config/apiBaseUrl';

export function canonicalChatVisitUlid(s: string | null | undefined): string {
  return (s ?? '').trim().toLowerCase();
}

const API_BASE = API_BASE_URL.replace(/\/$/, '');

export function getTeleconsultStaffChatHubUrl(): string {
  return `${API_BASE}/hubs/teleconsult-staff-chat`;
}

export type StaffChatUpdatedPayload = {
  visitUlid?: string;
  chatUlid?: string;
  chatConversation?: string;
  conversationType?: string;
  /** open | solved | pendingPartner | closed (newer API only). */
  status?: string;
  isClosed?: boolean;
  isClosingPending?: boolean;
  isPendingPartner?: boolean;
  autoCloseAtUtc?: string | null;
};

export type PatientReadyForMeetPayload = {
  visitUlid?: string;
  patientName?: string;
};

export type MeetPresenceUpdatedPayload = {
  visitUlid?: string;
  patientInRoom?: boolean;
};

export function canonicalChatUlid(s: string | null | undefined): string {
  return (s ?? '').trim().toLowerCase();
}

export function buildTeleconsultStaffChatHubConnection(args: {
  hubUrl: string;
  accessToken?: string | null;
  onStaffChatUpdated: (payload: StaffChatUpdatedPayload) => void;
  onPatientReadyForMeet?: (payload: PatientReadyForMeetPayload) => void;
  onTeleVisitQueueUpdated?: () => void;
  onMeetPresenceUpdated?: (payload: MeetPresenceUpdatedPayload) => void;
}): signalR.HubConnection {
  const {
    hubUrl,
    accessToken,
    onStaffChatUpdated,
    onPatientReadyForMeet,
    onTeleVisitQueueUpdated,
    onMeetPresenceUpdated,
  } = args;
  const hasQuery = hubUrl.includes('?');
  const url = accessToken
    ? `${hubUrl}${hasQuery ? '&' : '?'}access_token=${encodeURIComponent(accessToken)}`
    : hubUrl;

  const conn = new signalR.HubConnectionBuilder()
    .withUrl(url, {
      transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling,
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .build();

  conn.on('StaffChatUpdated', (payload: StaffChatUpdatedPayload) => {
    onStaffChatUpdated(payload ?? {});
  });

  if (onPatientReadyForMeet) {
    conn.on('PatientReadyForMeet', (payload: PatientReadyForMeetPayload) => {
      onPatientReadyForMeet(payload ?? {});
    });
  }

  if (onTeleVisitQueueUpdated) {
    conn.on('TeleVisitQueueUpdated', () => {
      onTeleVisitQueueUpdated();
    });
  }

  if (onMeetPresenceUpdated) {
    conn.on('MeetPresenceUpdated', (payload: MeetPresenceUpdatedPayload) => {
      onMeetPresenceUpdated(payload ?? {});
    });
  }

  return conn;
}

export function buildNormalSupportStaffChatHubConnection(args: {
  hubUrl: string;
  accessToken?: string | null;
  onStaffChatUpdated: (payload: StaffChatUpdatedPayload) => void;
}): signalR.HubConnection {
  const conn = buildTeleconsultStaffChatHubConnection(args);
  return conn;
}
